export default __webpack_public_path__ + "static/media/fast-rides-section.67240cd2.webp";